// extracted by mini-css-extract-plugin
module.exports = {"ko-KR":"banner_ko-KR__SrBdD","impressionTrackingContainer":"banner_impressionTrackingContainer__zL_nD","banner":"banner_banner__rsksl"};